module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedLight.6b2390f.woff2";